import { DIAMOND_REQUEST_FAILED, DIAMOND_REQUEST_START, DIAMOND_REQUEST_SUCCESS, DIAMOND_UPDATE, DIAMOND_UPDATE_HASMORE } from "./diamondTypes"

const initialState = {
    loading: false,
    diamonds: [],
    error: '',
    hasMore: true,
    lastDocId: null
}

const diamondReducer = (state = initialState, action) => {
    switch (action.type) {
        case DIAMOND_REQUEST_START:
            return { ...state, loading: true }
        case DIAMOND_REQUEST_SUCCESS:
            return {
                ...state,
                diamonds: [...state.diamonds, ...action.payload.diamonds],
                hasMore: action.payload.hasMore,
                lastDocId: action.payload.lastDocId,
                loading: false
            }
        case DIAMOND_REQUEST_FAILED:
            return { ...state, loading: false, diamonds: [], error: action.payload }
        case DIAMOND_UPDATE_HASMORE:
            return { ...state, hasMore: action.payload }
        case DIAMOND_UPDATE:
            return {...state, diamonds: action.payload};
    
        default: return state;
    }
}

export default diamondReducer;